exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pr-letters[data-v-989a7812]{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap}.letter-box .letter-p[data-v-989a7812]{display:inline;padding:5px;margin:0}.letter-box[data-v-989a7812]:before{background-color:#fff;content:\"\";display:inline-block;height:1px;position:relative;vertical-align:middle;width:5%;border-bottom:1px solid}.letter-box[data-v-989a7812]:after{background-color:#fff;content:\"\";display:inline-block;height:1px;position:relative;vertical-align:middle;width:90%;border-bottom:1px solid}@media (max-width: 767px){.letter-box[data-v-989a7812]:after{width:80%}}\n", ""]);

// exports
